/**
 * EmployeeAvatar Component
 * Avatar display for employee with fallback to initials
 */

import React from 'react';
import { Avatar, AvatarProps } from '@mui/material';
import { Person } from '@mui/icons-material';
import { getInitials } from '../../utils/employeeFormatters';

interface EmployeeAvatarProps extends Omit<AvatarProps, 'src' | 'alt'> {
  name: string;
  avatarUrl?: string | null;
  size?: 'small' | 'medium' | 'large';
}

const sizeMap = {
  small: { width: 32, height: 32, fontSize: '0.875rem' },
  medium: { width: 40, height: 40, fontSize: '1rem' },
  large: { width: 56, height: 56, fontSize: '1.25rem' }
};

export const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  name,
  avatarUrl,
  size = 'medium',
  sx,
  ...props
}) => {
  const sizeStyle = sizeMap[size];
  const initials = getInitials(name);

  if (avatarUrl) {
    return (
      <Avatar
        src={avatarUrl}
        alt={name}
        sx={{ ...sizeStyle, ...sx }}
        {...props}
      />
    );
  }

  return (
    <Avatar
      sx={{
        ...sizeStyle,
        bgcolor: 'primary.main',
        fontSize: sizeStyle.fontSize,
        fontWeight: 600,
        ...sx
      }}
      {...props}
    >
      {initials || <Person />}
    </Avatar>
  );
};
